import React from 'react';
import pure from 'recompose/pure';
import SvgIcon from './svg/SvgIcon';

const iconStyle = {
  // width: 22,
  // height: 22,
};

const Upload = ({ color, style, ...props }) => (
  /* eslint-disable max-len */
  <SvgIcon {...props} viewBox="0 0 32 32" style={{ ...style, ...iconStyle }}>
    <path
      fill={color || '#C4C8CE'}
      d="M12.025 16.156l-.756-.756 4.774-4.775L20.82 15.4l-.757.756-3.488-3.488v13.956h-1.07V12.668l-3.48 3.488zm14.17-6.587c0-.09.01-.17.01-.25 0-4.57-3.7-8.27-8.268-8.27-3.287 0-6.12 1.925-7.45 4.706C9.912 5.47 9.262 5.3 8.575 5.3c-2.112 0-3.862 1.537-4.2 3.55C1.862 9.713.05 12.094.05 14.9c0 3.53 2.862 6.394 6.394 6.394h6.938v-1.07H6.444c-2.938 0-5.325-2.393-5.325-5.33 0-2.275 1.45-4.3 3.605-5.044l.6-.206.106-.625c.264-1.545 1.588-2.663 3.15-2.663.5 0 .982.12 1.432.344l.975.488.47-.98c1.187-2.482 3.73-4.09 6.48-4.09 3.97 0 7.2 3.232 7.2 7.2 0 .02 0 .045-.006.07-.005.05-.005.106-.005.162l-.025 1.088 1.087.006c2.637.006 4.787 2.162 4.787 4.8 0 2.63-2.144 4.78-4.775 4.794h-7.49v1.07h7.495c3.225-.02 5.837-2.638 5.837-5.864-.006-3.244-2.62-5.87-5.85-5.875z"
    />
  </SvgIcon>
  /* eslint-enable max-len */
);

export default pure(Upload);
